import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import Sidebar from './components/layout/Sidebar';
import MobileNav from './components/layout/MobileNav';
import DashboardView from './components/dashboard/DashboardView';
import ChatView from './components/chat/ChatView';
import EntriesView from './components/entries/EntriesView';
import TasksView from './components/tasks/TasksView';
import RisksView from './components/risks/RisksView';
import PeopleView from './components/people/PeopleView';
import ContextsView from './components/contexts/ContextsView';
import DecisionsView from './components/decisions/DecisionsView';
import WeeklyView from './components/weekly/WeeklyView';
import EntryDetailModal from './components/entries/EntryDetailModal';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.xpertus.net';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');
  const [apiStatus, setApiStatus] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [selectedEntryId, setSelectedEntryId] = useState(null);

  const checkHealth = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/health`);
      setApiStatus(res.ok);
    } catch {
      setApiStatus(false);
    }
  }, []);

  useEffect(() => {
    checkHealth();
    const interval = setInterval(checkHealth, 60000);
    return () => clearInterval(interval);
  }, [checkHealth]);

  function showToast(message, type = 'success') {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }].slice(-3));
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }

  function openEntryDetail(entryId) {
    setSelectedEntryId(entryId);
  }

  return (
    <div className="app-shell">
      <Sidebar currentView={currentView} onNavigate={setCurrentView} apiStatus={apiStatus} />

      <main className="main-area">
        {currentView === 'dashboard' && (
          <DashboardView onEntryClick={openEntryDetail} onNavigate={setCurrentView} />
        )}
        {currentView === 'chat' && (
          <ChatView onNavigateToEntries={() => setCurrentView('entries')} />
        )}
        {currentView === 'entries' && (
          <EntriesView showToast={showToast} />
        )}
        {currentView === 'contexts'  && <ContextsView showToast={showToast} />}
        {currentView === 'tasks'     && <TasksView showToast={showToast} />}
        {currentView === 'risks'     && <RisksView showToast={showToast} />}
        {currentView === 'decisions' && <DecisionsView showToast={showToast} />}
        {currentView === 'people'    && <PeopleView />}
        {currentView === 'weekly'    && <WeeklyView showToast={showToast} />}
      </main>

      <MobileNav currentView={currentView} onNavigate={setCurrentView} />

      <EntryDetailModal
        entryId={selectedEntryId}
        onClose={() => setSelectedEntryId(null)}
        showToast={showToast}
      />

      {toasts.length > 0 && (
        <div className="toast-container">
          {toasts.map(t => (
            <div key={t.id} className={`toast toast--${t.type}`}>
              <span>{t.type === 'success' ? '✓' : t.type === 'info' ? 'ℹ' : '✗'}</span>
              <span>{t.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;
